import React, { forwardRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { ClickableLinkProps } from './ClickableLink.types';

export const ClickableLink = forwardRef<HTMLAnchorElement, ClickableLinkProps>(
  ({ className, disabled, href, onClick, target, ...rest }, ref) => {
    const Component = disabled ? 'span' : 'a';
    const defaultClasses = [
      'aria-[disabled=true]:cursor-not-allowed',
      'aria-[disabled=true]:opacity-40',
      'aria-[disabled=true]:hover:opacity-40',
    ];

    return (
      <Component
        ref={ref}
        {...(!disabled && { href, onClick, target })}
        {...(disabled && { 'aria-disabled': true, role: 'link', tabIndex: -1 })}
        className={cn(defaultClasses, className)}
        {...rest}
      />
    );
  },
);
